import { Box, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";

const PaginationWithSearch = ({ api, meta, search, loading, otherProps }) => {
  const dispatch = useDispatch();
  const [pageNum, setPageNum] = useState(1);
  const [limit] = useState(10);

  const handleNext = () => {
    setPageNum((prev) => prev + 1);
  };

  const handlePrev = () => {
    if (pageNum > 1) {
      setPageNum((prev) => prev - 1);
    }
  };

  useEffect(() => {
    const data = {
      page: pageNum,
      limit: limit,
      search: search,
      ...otherProps,
    };

    dispatch(api(data));
  }, [pageNum, search,otherProps?.feeStatus]);

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={2}
        p={2}
      >
        <IconButton
          color="primary"
          size="small"
          sx={{ border: 1, borderRadius: "50%", height: 30, width: 30 }}
          onClick={handlePrev}
          disabled={pageNum === 1 || loading}
        >
          <Icon icon="fluent:ios-arrow-24-filled" width="21" height="21" />
        </IconButton>

        <Typography variant="body1">
          Page: <strong>{pageNum}</strong>, Limit: <strong>{limit}</strong>
        </Typography>

        <IconButton
          disabled={loading || meta?.hasNextPage == false ? true : false}
          color="primary"
          size="small"
          sx={{ border: 1, borderRadius: "50%", height: 30, width: 30 }}
          onClick={handleNext}
        >
          <Icon
            style={{ transform: "rotate(180deg)" }}
            icon="fluent:ios-arrow-24-filled"
            width="21"
            height="21"
          />
        </IconButton>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="body1">
          Records: <strong>{meta?.totalRecords}</strong>
        </Typography>
      </Box>
    </>
  );
};

export default PaginationWithSearch;
